import { FC } from "react";
import styles from "./Form.module.scss";
import { getScreenSize } from "@utils/getScreenSize";
import { Tooltip } from "react-tooltip";
import TooltipIcon from "@components/icons/tooltip/TooltipIcon";

const FormHeadline: FC = () => {
    const { isMobile } = getScreenSize();
    return (
        <div className={styles.header}>
            {!isMobile && <h2 className={styles.headline}>Checker SCAM</h2>}
            <div className={styles.tooltip}>
                <a className="tooltipScam">
                    <TooltipIcon type="help" />
                </a>
                <Tooltip className="tooltip" classNameArrow="tooltipArrow" anchorSelect=".tooltipScam">
                    Fill in all the fields in as much detail as possible, <br /> our team will analyze the project/token
                    and give
                    <br /> its assessment in the table on the right
                </Tooltip>
            </div>
        </div>
    );
};

export default FormHeadline;
